import { Col, Container, Row } from "react-bootstrap";
import MemberLoginForm from "./Utility/MemberLoginForm";
import { ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import MemberPanelAuth from "../../Utilities/MemberPanelAuth";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import MemberLoginLogoArea from "./Utility/MemberLoginLogoArea";
import MemberSearchArea from "./Utility/MemberSearchArea";

function MemberLoginComponent(props) {
  // hooks
  const location = useLocation();
  const navigate = useNavigate();
  // getting data from redux store
  const { is_auth } = useSelector((state) => state.memberPanelAuthSlice);
  // token existance
  const { token } = MemberPanelAuth.getSessionData();

  useEffect(() => {
    if (token) {
      navigate("/member-panel");
    }
  }, [location, is_auth]);
  if (!token) {
    return (
      <>
        <section className="memberLoginSec">
          <Container>
            <Row className="justify-content-center">
              <Col md={4} sm={12}>
                <div className="loginBox">
                  <MemberLoginLogoArea />
                  {/* login form */}
                  <MemberLoginForm />
                </div>
              </Col>

            </Row>
            <Row className="justify-content-center">

              <Col md={4} sm={12} className="mt-5 serchBer">
                <h5>Serch Your Profile for id </h5>
                <MemberSearchArea />
              </Col>
            </Row>
          </Container>

          {/* toast container */}
          <ToastContainer />
        </section>
      </>
    );
  } else {
    return <>Authenticating...</>;
  }
}

export default MemberLoginComponent;
